import { render } from "./authenticationPage.vue?vue&type=template&id=74f5f19a&scoped=true&ts=true"
import script from "./authenticationPage.ts?vue&type=script&lang=ts"
export * from "./authenticationPage.ts?vue&type=script&lang=ts"

import "./authenticationPage.scss?vue&type=style&index=0&id=74f5f19a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f5f19a"]])

export default __exports__